module.exports = __webpack_public_path__ + "img/9788959064106.03242d7c.jpg";